import { render, staticRenderFns } from "./JuradoForm.vue?vue&type=template&id=61856793"
import script from "./JuradoForm.vue?vue&type=script&lang=js"
export * from "./JuradoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports